import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { error } from 'protractor';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthenticationService } from '../http-services/authentication.service';

@Injectable()
export class AuthInterceptorService implements HttpInterceptor {

  constructor(public authenticationService: AuthenticationService,
    private router: Router) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const isLoggedIn = this.authenticationService.isUserLoggedIn();
    if (isLoggedIn) {
      req = req.clone({
        setHeaders: {
          Authorization: 'Bearer ' + localStorage.getItem("token")
        }
      })
    }
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status == 403) {
          localStorage.removeItem("token")
          this.router.navigate(["/login"])
        }
        return throwError(error)
      })
    )
  }
}
